<div *ngIf="visible_price_categories.length > 1; else normalPrice" class="price_category-selector">

  <ion-item *ngIf="config_data.price_category_widget === PriceCategoryWidget.SELECT; else radio" style="--background: transparent">
    <ion-label position="stacked">Preiskategorie auswählen</ion-label>

    <ion-select (ionChange)="select_category($event.detail.value)" okText="Ok" cancelText="Zurück" [value]="registration.price_category">

      <ng-container *ngFor="let price_category of visible_price_categories">
        <ion-select-option [value]="price_category.id">
          {{ price_category.name }} ({{ price_category.price |price }})
        </ion-select-option>
      </ng-container>
    </ion-select>
  </ion-item>
</div>

<ng-template #normalPrice>
  <p *ngIf="visible_price_categories.length">Normalpreis ({{ visible_price_categories[0].price |price }})</p>
</ng-template>

<ng-template #radio>
  <ion-item style="--background: transparent">
    <ion-label position="stacked">Preiskategorie auswählen</ion-label>

    <ion-radio-group [value]="registration.price_category" (ionChange)="select_category($event.detail.value)">
      
      <ng-container *ngFor="let price_category of visible_price_categories">
        <ion-item style="--background: transparent">
          <ion-label>{{ price_category.name }} ({{ price_category.price |price }})</ion-label>
          <ion-radio slot="start" [value]="price_category.id"></ion-radio>
        </ion-item>
      </ng-container>
    </ion-radio-group>
  </ion-item>
</ng-template>
